// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.input-error[data-v-55708d1e]{font-family:\"SuisseIntl\",arial,sans-serif,\"Space\";font-size:1.4rem;font-weight:400;line-height:2rem;color:#28292b;color:#b70037;width:100%;cursor:text;display:flex;align-items:flex-start;grid-gap:.8rem;gap:.8rem}.input-error-icon[data-v-55708d1e]{width:2.4rem;min-width:2.4rem;height:2.4rem}.input-error span[data-v-55708d1e]{display:block;margin-top:.4rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
